import React from 'react';
import { useSchool } from '../../DataStore/SchoolContext';
import { useFeesDiscount } from '../../DataStore/FeesDiscountContext';

const DiscountListHead = () => {

    const {classOptions } = useSchool();
    const { dispatch, filter, searchText} = useFeesDiscount();

      const handleClass = (e)=>{
            dispatch({type: 'classId', payload: e.target.value})
        }

    

    return (
        <div className="card-header d-flex justify-content-between align-items-center">
        {/* Title */}
        <div className="card-header-title font-size-sm text-capital font-weight-normal">Discount Listing</div>

        {/* Filters */}
        <div className="d-flex">
            
            {/* Search Input with Icon */}
            <div className="input-group mr-2" style={{ maxWidth: '300px' }}>
                <span className="input-group-text">
                    <i className="fa fa-search"></i>
                </span>
                <input
                    type="text"
                    className="form-control"
                    placeholder="Find student..."
                    value={searchText}
                    onChange={(e) => dispatch({type:'searchText', payload: e.target.value})}
                />
            </div>

            <select className="form-control mr-2" style={{ maxWidth: '150px' }} onChange={handleClass}>
                {Array.isArray(classOptions) && classOptions.map((item, key)=>
                    <option value={item.value} key={key}>{item.title}</option>
                )}
            </select>


            
            <button className='btn btn-primary ml-2' onClick={filter}>Go</button>
        </div>
    </div>
    );
};

export default DiscountListHead;